import React, { useEffect, useState } from "react";
import {
  Table,
  Input,
  Button,
  Space,
  Select,
  Tag,
  Divider,
  Image,
  Spin,
  Row,
  Col,
  PageHeader,
} from "antd";
import Highlighter from "react-highlight-words";
import {
  FileExcelOutlined,
  FilePdfOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import _ from "lodash";
import moment from "moment";
import { connect } from "react-redux";
import { ImageView } from "../../image/imageView";
import { LanguageContext } from "../../../context/LanguageContext";
import { notificationAction } from "../../../_actions/notifications.actions";

class CountPreventiveNotificationListMemo extends React.Component {
  static contextType = LanguageContext;

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  getSerialNumber = (index, currentPage, pageSize) => {
    console.log("index, currentPage, pageSize", index, currentPage, pageSize);
    return (currentPage - 1) * pageSize + index;
  };

  render() {
    console.log("this.props.data", this.props.data);
    const { language, t } = this.context;
    let tempColumns = [];
    let columnsOb =
      this.props.data.length > 0
        ? [
            {
              title: t("sr.no"),
              key: t("sr.no"),
              render: (text, record) => (
                <Space size="middle" style={{ maxWidth: 300 }}>
                  {record.srNo}
                </Space>
              ),
            },
            {title: t("action_taken_police_station"),
              key: "action_taken_police_station",
              dataIndex: "action_taken_police_station",
              onHeaderCell: () => ({
                style: {
                  backgroundColor: "#ffcc80",
                  color: "#000",
                  fontWeight: "bold",
                },
              }),
              onCell: () => ({
                style: {
                  backgroundColor: "#ffcc80",
                  color: "#000",
                },
              }),
              sorter: {
                compare: (a, b) =>
                  a.action_taken_police_station - b.action_taken_police_station,
              },
              render: (text, record) => (
                <Space size="middle" style={{ maxWidth: 300 }}>
                  {record?.action_taken_police_station}
                </Space>
              ),
            },
              {
              title: t("preventive_action"),
              key: "preventive_action_name",
              dataIndex: "preventive_action_name",
              sorter: {
                compare: (a, b) =>
                  a.preventive_action_name - b.preventive_action_name,
              },
              render: (text, record) => (
                <>
                  <p>{record?.preventive_action_name}</p>
                  <p>{record?.action_taken_police_station}</p>
                </>
              ),
            },
            {
              title: t("date_from"),
              key: "date_from",
              dataIndex: "date_from",
              sorter: {
                compare: (a, b) =>
                  a.date_from - b.date_from,
              },
              render: (text, record) => (
                <Space size="middle" style={{ maxWidth: 300 }}>
                  {moment(record?.date_from).format("DD/MM/YYYY")}
                </Space>
              ),
            },

            {
              title: t("date_to"),
              key: "date_to",
              dataIndex: "date_to",
              sorter: {
                compare: (a, b) =>
                  a.date_to - b.date_to,
              },
              render: (text, record) => (
                <Space size="middle" style={{ maxWidth: 300 }}>
                  {moment(record?.date_to).format("DD/MM/YYYY")}
                </Space>
              ),
            },
            {
              title: t("name_of_the_accused"),
              key: "name",
              dataIndex: "name",
              sorter: {
                compare: (a, b) =>
                  a.basic_name - b.basic_name,
              },
              render: (text, record) => (
                <Space
                  size="middle"
                  style={{ maxWidth: 300 }}
                  title={record.masterid}
                >
                  {record?.basic_name}
                </Space>
              ),
            },
            {
              title: t("address"),
              key: "address",
              dataIndex: "address",
              sorter: {
                compare: (a, b) =>
                  a.address - b.address,
              },
              render: (text, record) => (
                <Space
                  size="middle"
                  style={{ maxWidth: 300 }}
                  title={record.masterid}
                >
                  {record?.address}
                </Space>
              ),
            },
          
            
            {
              title: t("crime_registration_date"),
              key: "name",
              dataIndex: "name",
              sorter: {
                compare: (a, b) =>
                  a.gunha_dateTime - b.gunha_dateTime,
              },
              render: (text, record) => (
                <>
                  <p>{record?.registernumber}</p>
                  <p> {moment(record?.gunha_dateTime).format("DD/MM/YYYY")}</p>
                  <p>{record?.guna_districtName}</p>
                </>
              ),
            },
            {
              title: "कायदा कलम",
              key: "name",
              dataIndex: "name",
              render: (text, record) => {
                const kkInfoArray = Array.isArray(record.kk_info)
                  ? record.kk_info
                  : [];

                if (kkInfoArray.length === 0) return null;

                // Group kalam → unique rules
                const grouped = kkInfoArray.reduce((acc, item) => {
                  const name = item?.rulesName || "-"; // rule name
                  const kalma = item?.kalam || "-"; // kalam

                  if (!acc[name]) {
                    acc[name] = [kalma];
                  } else if (!acc[name].includes(kalma)) {
                    acc[name].push(kalma);
                  }
                  return acc;
                }, {});

                return (
                  <Space
                    direction="vertical"
                    size="small"
                    style={{ maxWidth: 300 }}
                  >
                    {Object.entries(grouped).map(([ruleName, kalams], idx) => (
                      <p key={idx}>
                        {`${ruleName}${
                          kalams.length ? " , " + kalams.join(", ") : ""
                        }`}
                      </p>
                    ))}
                  </Space>
                );
              },
            },
            {
              title:"अलर्ट दिनांक",
              key: "date",
              render: (text, record) => (
                <Space
                  direction="vertical"
                  size="small"
                  style={{ maxWidth: 300 }}
                >
                  {moment(record.date).format("DD-MM-YYYY")}
                </Space>
              ),
            },           
          ]
        : [];

    let tableData =
      this.props.data?.map((item, index) => ({
        ...item,
        srNo: index + 1,
      })) || [];

    // columns.push(
    //   ...columnsOb
    // );

    return (
      <>
        <Spin spinning={this.props.loading} delay={500}>
          <div style={{ marginBottom: 16 }}>
            <span style={{ marginLeft: 8 }}></span>
          </div>

          <Table
            key={tableData}
            columns={columnsOb}
            dataSource={tableData}
            // pagination={{
            //   current: this.props.currentPage,
            //   pageSize: this.props.pageSize,
            //   total: this.props.total,
            //   onChange: this.props.handlePageChange,
            //   onShowSizeChange: this.props.handlePageSizeChange,
            //   showSizeChanger: true,
            // }}
          />
        </Spin>
      </>
    );
  }
}

function mapStateToProps(state) {
  const { users, authentication, professionals } = state;
  const { user } = authentication;
  return {
    user,
    users,
    professionals,
  };
}
const connectedTableWanted = connect(mapStateToProps)(
  CountPreventiveNotificationListMemo
);
export { connectedTableWanted as CountPreventiveNotificationList };
